
export type GetCourseDraftAssetsParams = {
/**
 * 페이지 번호 (0부터 시작)
 */
page?: number;
/**
 * 페이지 당 항목 수
 */
size?: number;
/**
 * 정렬 기준 (예: createdAt,desc 또는 title,asc)
 */
sort?: string;
};
